module.exports = __webpack_public_path__ + "img/study-statistics-icon01.e28d017a.png";